import React, { Fragment } from 'react';
import MenuItemSeparator from 'tradera-components/site-header/dropdown-menu-item-separator';
import MenuItem from 'tradera-components/site-header/dropdown-menu-item';
import ExpandableMenuItem from 'tradera-components/site-header/dropdown-menu-item-expandable';
import GtmService from 'static/script/app/ui/google-tagmanager-service';
import { getMenuGaAttributes } from 'tradera-components/site-header/site-header.analytics';
import STRINGS from 'static/script/constants/strings';
import { getReturnUrl } from 'tradera-utils/login';
import logger from 'logger';
import { useTranslator, useUrlLocalizer } from 'tradera-lang';
import * as mopinion from 'static/script/components/customer-feedback/mopinion-loader';
import { getInitData } from 'packages/init-data';

import ChatIcon from '@tradera/blueprint/theme/icons2/chat.svg?jsx';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';

const onIframeLoad = (e, closeMenu) => {
    const iframe = e.target;
    if (iframe) {
        const iframeDocument =
            iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDocument) {
            iframeDocument.body.addEventListener('keydown', e => {
                if (e.keyCode === 27) {
                    closeMenu();
                }
            });
        }
    }
};

const handleBotClick = () => {
    const botWidget = document.querySelector('.humany-trigger');
    if (botWidget) {
        botWidget.click();
    }
};

const getGaAttributes = label =>
    getMenuGaAttributes('Top navigation', 'Login menu', label);

const trackOnClick = label => {
    GtmService.trackAction('Top navigation', 'Login menu', `Link - ${label}`);
};

const trackExpandItemClick = label => {
    GtmService.trackAction('Top navigation', 'Login menu', label);
};

const SignInMenuContent = ({ closeMenu, redirectUrl }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const initData = getInitData();
    return (
        <Fragment>
            <iframe
                className="w-100"
                src={toLocalizedUrl(
                    `${window.location.origin}/login${getReturnUrl(
                        redirectUrl
                    )}&login-modal=true`
                )}
                id="sign-in-modal"
                title="Login"
                name="LoginIframe"
                data-sign-in-modal
                onLoad={e => onIframeLoad(e, closeMenu)}>
                <p>{STRINGS.IFRAME_NOT_SUPPORTED}</p>
            </iframe>
            <ExpandableMenuItem
                label={t('siteheader_needHelp')}
                className="site-dropdown__item-with-icon text-inter-medium"
                icon={<InfoIcon className="icon" />}
                border={false}
                onOpen={() => trackExpandItemClick('Open - Help')}
                onClose={() => trackExpandItemClick('Close - Help')}>
                <MenuItem
                    label={t('siteheader_forgotPassword')}
                    link={toLocalizedUrl('/login/forgotusercredentials')}
                    className="site-dropdown__item-with-icon"
                    icon={<InfoIcon className="icon" />}
                    gaAttributes={getGaAttributes('Forgot')}
                />
                <MenuItem
                    label={t('siteheader_helpPages')}
                    link="https://info.tradera.com/"
                    className="site-dropdown__item-with-icon"
                    icon={<InfoIcon className="icon" />}
                    gaAttributes={getGaAttributes('Help pages')}
                />
                <MenuItem
                    label={t('siteheader_contactCustomerService')}
                    link="https://info.tradera.com/#humany-vanliga-fragor-och-svar=/contact/"
                    className="site-dropdown__item-with-icon"
                    icon={<ChatIcon className="icon" />}
                    gaAttributes={getGaAttributes('Customer service')}
                />

                <MenuItem
                    label={t('siteheader_chatWithBot')}
                    className="site-dropdown__item-with-icon"
                    icon={<ChatIcon className="icon" />}
                    onClick={async () => {
                        try {
                            const { default: AddHumanyBot } = await import(
                                /* webpackChunkName: "humany-bot" */ 'static/script/components/humany/humany-bot'
                            );
                            AddHumanyBot(initData);
                            handleBotClick();
                        } catch (e) {
                            logger(e);
                        }

                        trackOnClick('Chat with JUNO');
                    }}
                />

                {mopinion.isEnabled() && (
                    <Fragment>
                        <MenuItem
                            label={t('siteheader_feedback')}
                            className="site-dropdown__item-with-icon"
                            icon={<ChatIcon className="icon" />}
                            onClick={() => {
                                mopinion.openMopinionWidget(
                                    mopinion.generalFeedbackForm
                                );
                                trackOnClick('Leave feedback');
                            }}
                        />
                    </Fragment>
                )}
                {/* NOTE: Fix for iPhone menu making bottom element unclickable */}
                <MenuItemSeparator className="site-dropdown__separator--bottom d-lg-none" />
            </ExpandableMenuItem>
        </Fragment>
    );
};

export default SignInMenuContent;
